import { render, staticRenderFns } from "./ChooseCreateNew.vue?vue&type=template&id=12f16fb2&"
import script from "./ChooseCreateNew.vue?vue&type=script&lang=js&"
export * from "./ChooseCreateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports